import React from "react";

interface CompleteModuleIconProps {
  className?: string;
  onClick?: () => void;
}

export const CompleteModuleIcon = ({
  className,
  onClick,
}: CompleteModuleIconProps) => (
  <svg
    width="40"
    height="34"
    viewBox="0 0 40 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
  >
    <circle cx="20.5" cy="17" r="16" stroke="#00A3A3" />
    <path
      d="M26.7148 10.9844C26.9023 10.7734 27.0898 10.7734 27.2773 10.9844L27.6992 11.3711C27.8867 11.582 27.8867 11.7812 27.6992 11.9688L17.1523 22.5156C16.9414 22.7266 16.7422 22.7266 16.5547 22.5156L12.3711 18.332C12.1836 18.1445 12.1836 17.9453 12.3711 17.7344L12.793 17.3477C12.8633 17.2539 12.957 17.207 13.0742 17.207C13.1914 17.207 13.2852 17.2539 13.3555 17.3477L16.8359 20.8281L26.7148 10.9844Z"
      fill="#00A3A3"
    />
  </svg>
);

CompleteModuleIcon.defaultProps = {
  className: "",
  onClick: undefined,
};
